import { ReactNode } from 'react';

import './InputTextfieldCombination.scss';

export type InputTextfieldCombinationProps = {
    label: string;
    children: ReactNode;
    isMandatory?: boolean;
};

export const InputTextfieldCombination = (props: InputTextfieldCombinationProps) => {
    const { label, children, isMandatory = false } = props;

    return (
        <article className="input-textfield-combination">
            <span className="input-textfield-combination__label">
                {label}
                {isMandatory && <span className="required-field"> *</span>}
            </span>
            <article className="input-textfield-combination__children">{children}</article>
        </article>
    );
};
